import { connect } from 'react-redux'
import Toaster from './component'
import { getToasts, getActiveQueue } from '../../selectors'
import { removeToast, buttonClicked } from '../../actions'
import { getLayout } from '../../imports'

function mapStateToProps(state) {
    const activeQueue = getActiveQueue(state)
    return {
        showButton: activeQueue.buttonEnabled,
        toasts: getToasts(state),
        position: 'topRight',
        animation: 'none',
        layout: getLayout(state),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        removeToast: (id) => {
            dispatch(removeToast(id))
        },
        toggleMenu: () => {
            dispatch(buttonClicked())
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Toaster)



// WEBPACK FOOTER //
// ./src/features/Toaster/components/Toaster/index.js